<template>
  <div class="guide">
    <div class="guide-left" id="guide-left">
      <div class="guide-left-content" id="guide-left-content">{{leftContent}}</div>
    </div>
    <div class="guide-right" id="guide-right">
      <div class="triangle" id="triangle"></div>
      <div class="right-header">
        <div class="right-title" id="right-title">{{leftContent}}</div>
        <div><el-checkbox v-model="isAgain">下次不再提示</el-checkbox></div>
      </div>
      <div class="right-title-bg"></div>
      <div class="right-content">{{rightContent}}</div>
      <div class="foot-btn-tool">
        <div class="foot-left">
          <div :class="['circle', circleIndex === item ? 'active-circle' : '']" v-for="item in circleList" :key="item" @click="circleClick(item)"></div>
        </div>
        <div class="foot-right">
          <div class="right-btn color-gry" v-if="circleIndex !== 3" @click="close">跳过</div>
          <div class="right-btn color-gry" v-if="circleIndex === 3" @click="close">关闭</div>
          <div class="right-btn color-gry" v-if="circleIndex !== 0" @click="goUp">上一步</div>
          <div class="right-btn color-rd" v-if="circleIndex !== 3" @click="goDown">下一步<i class="el-icon-arrow-right"></i></div>
          <div class="right-btn color-rd" v-if="circleIndex === 3" @click="goJump">进入快速对接<i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
export default {
  name: 'NoviceGuide',
  props: {
    options: {
      type: Array,
      default: () => { return [] }
    }
  },
  data() {
    return {
      leftContent: '',
      rightContent: '',
      isAgain: true,
      circleList: [0, 1, 2, 3],
      circleIndex: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
    window.addEventListener('resize', this.getInit);
  },
  methods: {
    getInit: debounce(function() {
      this.againInit()
    }, 30),
    close() { // 跳过 / 关闭
      if (this.isAgain) {
        this.$API.changeGuideStatus()
      }
      this.$emit('guideclose')
    },
    goUp() { // 上一步
      this.circleIndex = this.circleIndex - 1
      this.againInit()
    },
    goDown() { // 下一步
      this.circleIndex = this.circleIndex + 1
      this.againInit()
    },
    goJump() { // 进入快速对接
      if (this.isAgain) {
        this.$API.changeGuideStatus()
      }
      this.$emit('guideclose', 'jump')
    },
    circleClick(index) {
      this.circleIndex = index
      this.againInit()
    },
    init() {
      if (this.options) {
        const first = document.getElementById(this.options[0].element) // 需要引导的第一个元素
        const left = this.getOffsetLeft(first) // 离左边的距离
        const top = this.getOffsetTop(first) // 离上边的距离
        const guideLeft = document.getElementById('guide-left')
        guideLeft.style.left = left - 10 + 'px'
        guideLeft.style.top = top + 10 + 'px'
        guideLeft.style.width = first.offsetWidth  + 'px'
        guideLeft.style.height = first.offsetHeight  + 'px'
        this.leftContent = this.options[0].title
        this.rightContent = this.options[0].content
        const guideLeftContent = document.getElementById('guide-left-content')
        guideLeftContent.style.width = first.offsetWidth - 27 + 'px'
        guideLeftContent.style.height = first.offsetHeight  + 'px'
        guideLeftContent.style.lineHeight = first.offsetHeight + 'px'
        const guideRight = document.getElementById('guide-right')
        guideRight.style.top = top + 10 + 'px'
        guideRight.style.left = left + first.offsetWidth + 25 + 'px'
      }
    },
    againInit() {
      const element = document.getElementById(this.options[this.circleIndex].element) // 需要引导的第一个元素
      const left = this.getOffsetLeft(element) // 离左边的距离
      const top = this.getOffsetTop(element) // 离上边的距离
      const guideLeft = document.getElementById('guide-left')
      guideLeft.style.left = left - 10 + 'px'
      guideLeft.style.top = top + 10 + 'px'
      guideLeft.style.width = element.offsetWidth  + 'px'
      guideLeft.style.height = element.offsetHeight  + 'px'
      this.leftContent = this.options[this.circleIndex].title
      this.rightContent = this.options[this.circleIndex].content
      const guideLeftContent = document.getElementById('guide-left-content')
      guideLeftContent.style.width = element.offsetWidth - 27 + 'px'
      guideLeftContent.style.height = element.offsetHeight  + 'px'
      guideLeftContent.style.lineHeight = element.offsetHeight + 'px'
      const guideRight = document.getElementById('guide-right')
      guideRight.style.top = top + 10 + 'px'
      guideRight.style.left = left + element.offsetWidth + 25 + 'px'
    },
    getOffsetLeft(obj) {
      var tmp = obj.offsetLeft
      var val = obj.offsetParent
      while(val !== null) {
        tmp += val.offsetLeft
        val = val.offsetParent
      }
      return tmp
    },
    getOffsetTop(obj) {
      var tmp = obj.offsetTop
      var val = obj.offsetParent
      while(val !== null) {
        tmp += val.offsetTop
        val = val.offsetParent
      }
      return tmp
    }
  }
}
</script>
<style scoped lang="scss">
.guide {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1001 !important;
  background-color: rgb(0,0,0,0.5);
  // opacity: 0.5;
  .guide-left {
    position: absolute;
    border: 2px dashed #ffffff;
    border-radius: 6px;
    padding: 8px 9px;
    .guide-left-content {
      background-color: #F4F4F4;
      border-radius: 6px;
      color: #E60000;
      font-size: 20px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      padding-left: 27px;
    }
  }
  .guide-right {
    position: absolute;
    background-color: #fff;
    box-shadow: 0 1px 10px rgb(0 0 0 / 40%);
    z-index: 1001;
    padding: 15px;
    border-radius: 6px;
    width: 280px;
    height: 135px;
    .triangle {
      position: absolute;
      border: 5px solid #fff;
      left: -10px;
      top: 15px;
      border-color: transparent #fff transparent transparent;
    }
    .right-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .right-title {
        width: 64px;
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        text-align: left;
        color: #000000;
        line-height: 16px;
        margin-left: 10px;
      }
    }
    .right-title-bg {
      width: 64px;
      height: 9px;
      background: rgba(230,0,0,0.09);
      border-radius: 2px;
      position: absolute;
      top: 28px;
      left: 28px;
    }
    .right-content {
      width: 210px;
      height: 65px;
      font-size: 12px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #000000;
      line-height: 18px;
      padding: 20px 0px 10px 15px;
    }
    .foot-btn-tool {
      padding-left: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .foot-left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .circle {
          width: 6px;
          height: 6px;
          border: 1px solid #bebebe;
          border-radius: 50%;
          margin-right: 5px;
        }
        .circle:hover {
          cursor: pointer;
          box-shadow: 0px 1px 5px rgb(230,0,0,40%);
          border-color: #e60000 !important;
        }
      }
      .foot-right {
        display: flex;
        .right-btn {
          font-size: 12px;
          font-weight: 400;
          font-family: PingFangSC, PingFangSC-Regular;
          margin-right: 10px;
        }
        .right-btn:hover {
          cursor: pointer;
          color: #E60000 !important;
        }
        .color-gry {
          color: #BEBEBE;
        }
        .color-rd {
          color: #E60000;
        }
      }
    }
  }
}
.active-circle {
  width: 6px;
  height: 6px;
  background: #e60000;
  border-color: #e60000 !important;
  border-radius: 50%;
}
</style>
